import { SiteMaintenance } from "../../assets/images";
import { useFormik } from "formik";
import * as Yup from "yup";
import * as PR from "../../prime-modules/index";
import "./UnderMaintenance.scss";
import { notifyEmail } from "../../services/api";
import { useToast } from "../../context/ToastContext";

const UnderMaintenance = () => {
  const { showToast } = useToast();

  const handleSubmit = (values, { resetForm }) => {
    console.log("   Submitting email:", values);

    notifyEmail({ email: values.email })
      .then(() => {
        showToast("success", "We will notify you once we are back online.");
        resetForm();
      })
      .catch((err) => {
        showToast("error", err?.message);
      });
  };

  const formik = useFormik({
    initialValues: { email: "" },
    validationSchema: Yup.object({
      email: Yup.string().email("Invalid email address").required("Email is required"),
    }),
    onSubmit: handleSubmit,
  });

  return (
    <div className="maintenance-wrapper">
      <div className="maintenance-content">
        <div className="grid align-items-center">
          <div className="col-12 md:col-6">
            <h1>
              WEBSITE IS UNDER <span>MAINTENANCE</span>
            </h1>
            <p>
              We're currently performing some scheduled maintenance to improve
              our services. We'll be back online shortly. Thank you for your
              patience!
            </p>
            <form autoComplete="off" className="form-block" onSubmit={formik.handleSubmit}>
              <PR.InputText
                id="email"
                name="email"
                placeholder="Enter email address"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <i className="pi pi-envelope"></i>

              <PR.Button
                label="Notify Me!"
                type="submit"
                className="goto-button"
              />
            </form>
          </div>
          <div className="col-12 md:col-6 text-center">
            <PR.Image
              src={SiteMaintenance}
              alt="Site Maintenance"
              className="maintenance-image"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnderMaintenance;
